import { store } from '@/state/store';
import { LOCAL__ui_grids2d_set_current_cell } from '@/state/ui/image/LOCAL__ui_grids2d_set_current_cell';
import { LOCAL__ui_grids2d_set_current_cell_neigbours } from '@/state/ui/image/LOCAL__ui_grids2d_set_current_cell_neigbours';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';

export function FN_GRID2D_GALLERY__set_cell_current(grid2d: DTO__grid2d, cell: DTO__grid2d_cell) {
  store.dispatch(LOCAL__ui_grids2d_set_current_cell(cell));

  let cells = grid2d.cells__get_list();
  let index = cells.findIndex(item => item._id == cell._id);

  if (index == -1) return;

  let index_start = index - 2;
  let index_end = index + 3;

  // 2. Shift window right if it overflows the left boundary (< 0)
  if (index_start < 0) {
    index_end += Math.abs(index_start);
    index_start = 0;
  }

  // 3. Shift window left if it overflows the right boundary (> total length)
  if (index_end > cells.length) {
    index_start -= index_end - cells.length;
    index_end = cells.length;
  }

  index_start = Math.max(index_start, 0);

  let cells_neighbours = cells.slice(index_start, index_end);

  store.dispatch(LOCAL__ui_grids2d_set_current_cell_neigbours([cells_neighbours]));
}
